import { Component } from '@angular/core';

@Component({
	selector: 'app-setup-wizard-view-previous-jobs',
	imports: [],
	standalone: true,
	templateUrl: './setup-wizard-view-previous-jobs.html',
	styleUrl: './setup-wizard-view-previous-jobs.scss',
})
export class SetupWizardViewPreviousJobs {}
